import React from 'react'
import { useAuth } from '../../Context/ContextProvider';
import { MdOutlineEmail, MdOutlineLocalPhone } from 'react-icons/md';
import { LuBuilding } from "react-icons/lu";

function Form() {
    const { webData } = useAuth()
    // const {contactUs,button_loading,formatPakistaniPhoneNumber,webData}=useAuth()
    // const [successMsg, setSuccessMsg] = useState("");

    // const [data, setData] = useState({
    //     name: "",
    //     email: "",
    //     phoneNumber: "",
    //     message: ""
    // })
    // const [errors, setErrors] = useState({});
    // const validate = () => {
    //     let errs = {};
    //     if (!data.name) errs.name = 'Name is required.';
    //     if (!data.email) errs.email = 'Email is required.';
    //     if (!data.phoneNumber) errs.phoneNumber = 'Phone number is required.';
    //     if (!data.message) errs.message = 'Message is required.';
    //     setErrors(errs); return Object.keys(errs).length === 0;
    //   }

    //   const handleChange = (e) => {
    //       setData({ ...data, [e.target.name]: e.target.value });
    //       setErrors({ ...errors, [e.target.name]: undefined });
    //       setErrors && setErrors({message:'', color:''}) // clear global error
    //   };

    //   const handleSubmit = async (e) => {
    //       e.preventDefault();
    //       setSuccessMsg("");
    //       if (!validate()) return;
    //       const resp = await contactUs(data);
    //       if (resp.success) {
    //           setSuccessMsg("Question submitted successfully!");
    //           setData({ name: "",
    //             email: "",
    //             phoneNumber: "",
    //             message: ""});
    //       }
    //   };
    return (
        <div className='form_section contact_us_form'>
            <div className='container'>
                <h5>Contact Us</h5>
                <div className='row mx-auto my-5  d-flex justify-content-center'>
                    <div className='col-lg-4 col-md-8 col-12 pe-lg-2 ps-lg-0 mt-0'>
                        {/* <form className='form' onSubmit={handleSubmit}>
                <div className='inp_box'>
                    <label>Name<span className='text-danger'>*</span></label>
                    <input name="name" value={data.name} onChange={handleChange} placeholder='Name' />
                    {errors.name && <div className="text-danger small">{errors.name}</div>}
                </div>
                <div className='inp_box'>
                    <label>Email<span className='text-danger'>*</span></label>
                    <input name="email" value={data.email} onChange={handleChange} placeholder='jhon@gmail.com' />
                    {errors.email && <div className="text-danger small">{errors.email}</div>}
                </div>
    
                <div className='inp_box'>
                    <label>Phone Number<span className='text-danger'>*</span></label>
                    <input name="phoneNumber" value={data.phoneNumber} onChange={(e)=>setData({...data, phoneNumber: formatPakistaniPhoneNumber(e.target.value)})} placeholder='3120123456' />
                    {errors.phoneNumber && <div className="text-danger small">{errors.phoneNumber}</div>}
                </div>
                <div className='inp_box mb-3'>
                    <label>Message<span className='text-danger'>*</span></label>
                    <textarea name="message" value={data.message} onChange={handleChange} placeholder='Type your message here...' />
                    {errors.message && <div className="text-danger small">{errors.message}</div>}
                </div>
                <div className='modal_bottom'>
                    <button className="submit_btn" type="submit" disabled={button_loading}>{button_loading ? 'Submitting...' : 'Submit'}</button>
                </div>
            </form> */}
                        <div className='contact_info'>
                            <h4>We’re Here to Help You.</h4>
                            <p>Have questions or need assistance? Our team is here to help you. Reach out to us through the contact information below, and we’ll get back to you as soon as possible.</p>
                            <ul>
                                <li className='mt-2'><LuBuilding className='icons' /> <a href={`https://maps.app.goo.gl/1234567890`} target='_blank' rel='noopener noreferrer'>{webData?.webSettings?.address}</a></li>
                                <li className='mt-2'><MdOutlineLocalPhone className='icons' /> <a href={`https://wa.me/${webData?.webSettings?.contact_number}`} target='_blank' rel='noopener noreferrer'>{webData?.webSettings?.contact_number}</a></li>
                                <li className='mt-2'><MdOutlineEmail className='icons' /> <a href={`mailto:${webData?.webSettings?.email}`} target='_blank' rel='noopener noreferrer'>{webData?.webSettings?.email}</a></li>
                            </ul>
                        </div>

                    </div>
                    <div className='col-lg-8 col-md-4 col-12  h-100 p-0 p-md-2'>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.48000076542!2d55.136936576071776!3d25.119457977761023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b00238d4d21%3A0xb91ab6bdd473b76!2sPink%20villa!5e0!3m2!1sen!2s!4v1767950155840!5m2!1sen!2s" width="600" height="450" style={{ border: 0, width: "100%", height: "400px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

                    </div>
                </div>

            </div>

        </div>
    )
}

export default Form